import { AuthProvider } from 'react-admin';

export const authProvider: AuthProvider = {
  login: async ({ username, password, email }) => {
    const baseUrl = import.meta.env.VITE_SIMPLE_REST_URL;

    // Use email if provided, otherwise fall back to username
    const loginEmail = email || username;

    try {
      const response = await fetch(`${baseUrl}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: loginEmail, password }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Login failed: ${response.status} - ${errorText}`);
      }

      const data = await response.json();

      localStorage.setItem('accessToken', data.accessToken);
      localStorage.setItem('refreshToken', data.refreshToken);
      localStorage.setItem('user', JSON.stringify(data.user));

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    return Promise.resolve();
  },

  checkAuth: () => {
    const token = localStorage.getItem('accessToken');
    return token ? Promise.resolve() : Promise.reject();
  },

  checkError: (error: any) => {
    if (error && (error.status === 401 || error.status === 403)) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getIdentity: () => {
    const user = localStorage.getItem('user');
    return user ? Promise.resolve(JSON.parse(user)) : Promise.reject();
  },

  getPermissions: () => {
    const user = localStorage.getItem('user');
    if (user) {
      const userData = JSON.parse(user);
      return Promise.resolve(userData.roles || []);
    }
    return Promise.reject();
  },
};
